"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.home = void 0;
var home = {
  name: 'Home',
  link: '/imovel',
  logo: 'Home',
  colors: {
    active: 'fontNeutral90',
    font: 'fontNeutral60',
    background: 'backgroundNeutral10'
  },
  links: [{
    id: 'troca-de-imoveis',
    label: 'Financie sua reforma',
    link: '/financiamento-reforma'
  }, {
    id: 'venda-de-imoveis',
    label: 'Venda',
    link: '/imovel/vender'
  }, {
    id: 'reforma-de-imoveis',
    label: 'Reforma',
    link: '/imovel/projeto'
  }, {
    id: 'loja-de-imoveis',
    label: 'Loja de imóveis',
    link: '/imovel/loja/'
  }]
};
exports.home = home;